import { ShopTypeEnum } from '../../general/services/shop-type.enum';
import { ScanCard } from './scan-card';

export class VuState {

  constructor(
    public isOfflineMode: boolean,
    public isServiceMode: boolean,
    public isBurglaryMode: boolean,
    public isMaintenanceMode: boolean,
    public maintenanceModeReasons: string[],
    public minHardwareConfigurationViolation: string,
    public token: string,
    public shopType: ShopTypeEnum,
    public scanCard?: ScanCard,
  ) {
  }

  get isValid(): boolean {
    return !this.isOfflineMode && !this.isServiceMode && !this.isBurglaryMode && !this.isMaintenanceMode;
  }

  static createFromAny(object: any): VuState {
    if (!object) {
      return null;
    }

    return new VuState(
      object.isOfflineMode,
      object.isServiceMode,
      object.isBurglaryMode,
      object.isMaintenanceMode,
      object.maintenaceModeReasons,
      object.minHardwareConfigurationViolation,
      object.token,
      object.shopType ? ShopTypeEnum[object.shopType] : null,
      object.scanCard ? ScanCard.createFromAny(object.scanCard) : null,
    );
  }
}
